import groq from 'groq'

import { frameBuilderDefaultFrameObjectFragment } from './default-frame'
import {
  frameBuilderExtraServiceObjectFragment,
  frameBuilderProductExtraServiceObjectFragment,
} from './extra-services'
import {
  frameBuilderGlassObjectFragment,
  frameBuilderProductGlassObjectFragment,
} from './glass'
import {
  frameBuilderPassepartoutColorObjectFragment,
  frameBuilderPassepartoutSizeObjectFragment,
  frameBuilderProductPassepartoutColorObjectFragment,
  frameBuilderProductPassepartoutSizeObjectFragment,
} from './passepartout'
import {
  frameBuilderProductProfileObjectFragment,
  frameBuilderProfileObjectFragment,
} from './profile'
import { frameBuilderProductSettingsObjectFragment } from './settings'
import {
  frameBuilderProductServicePricesObjectFragment,
  frameBuilderServicePricesObjectFragment,
} from './service-prices'
import {
  frameBuilderProductSpacerColorObjectFragment,
  frameBuilderProductSpacerSizeObjectFragment,
  frameBuilderSpacerColorObjectFragment,
  frameBuilderSpacerSizeObjectFragment,
} from './spacer'
import {
  frameBuilderProductStandardSizeObjectFragment,
  frameBuilderStandardSizeObjectFragment,
} from './standard-size'
import {
  frameBuilderProductStringsObjectFragment,
  frameBuilderStringsObjectFragment,
} from './strings'
import {
  frameBuilderProductTextureObjectFragment,
  frameBuilderTextureObjectFragment,
} from './texture'

export const frameBuilderModuleFragment = groq`
  updateHash,
  showExtrasStep,
  showProgressBar,
  ${frameBuilderStringsObjectFragment}
  ${frameBuilderDefaultFrameObjectFragment}
  ${frameBuilderServicePricesObjectFragment}
  ${frameBuilderProfileObjectFragment}
  ${frameBuilderTextureObjectFragment}
  ${frameBuilderPassepartoutSizeObjectFragment}
  ${frameBuilderPassepartoutColorObjectFragment}
  ${frameBuilderGlassObjectFragment}
  ${frameBuilderSpacerSizeObjectFragment}
  ${frameBuilderSpacerColorObjectFragment}
  ${frameBuilderStandardSizeObjectFragment}
  ${frameBuilderExtraServiceObjectFragment}
`

export const frameBuilderQuery = groq`
  {
    ${frameBuilderStringsObjectFragment}
    ${frameBuilderDefaultFrameObjectFragment}
    ${frameBuilderServicePricesObjectFragment}
    ${frameBuilderProfileObjectFragment}
    ${frameBuilderTextureObjectFragment}
    ${frameBuilderPassepartoutSizeObjectFragment}
    ${frameBuilderPassepartoutColorObjectFragment}
    ${frameBuilderGlassObjectFragment}
    ${frameBuilderSpacerSizeObjectFragment}
    ${frameBuilderSpacerColorObjectFragment}
    ${frameBuilderStandardSizeObjectFragment}
    ${frameBuilderExtraServiceObjectFragment}
  }
`

export const frameBuilderProductQuery = groq`
  {
    ${frameBuilderProductStringsObjectFragment}
    ${frameBuilderProductSettingsObjectFragment}
    ${frameBuilderProductServicePricesObjectFragment}
    ${frameBuilderProductProfileObjectFragment}
    ${frameBuilderProductTextureObjectFragment}
    ${frameBuilderProductPassepartoutSizeObjectFragment}
    ${frameBuilderProductPassepartoutColorObjectFragment}
    ${frameBuilderProductGlassObjectFragment}
    ${frameBuilderProductSpacerSizeObjectFragment}
    ${frameBuilderProductSpacerColorObjectFragment}
    ${frameBuilderProductStandardSizeObjectFragment}
    ${frameBuilderProductExtraServiceObjectFragment}
  }
`
